import styled from 'styled-components';

export const ContainerStyled = styled.div`
  box-sizing: border-box;
  max-width: 85%;
  min-width: 294px;
  margin: 0 auto;
  padding: 0;
  background-color: transparent;
  position: relative;

  @media screen and (min-width: 1299.8px) {
    width: 1194px;
  }
`;
